import styled from '@emotion/styled'

import { Media, type MediaProps } from '@/components/Media'
import { BodyM } from '@/components/Typography'

export interface BlogProps {
  title: {
    text: string
    tag?: string
  }
  midia: MediaProps
  description: string
  link?: string
  width?: string
  height?: string
}

const BlogStyles = styled.div({
  width: '100%',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  borderRadius: 'var(--radii-default)',
  boxShadow: '0 4px 9px 0 rgba(var(--theme-black), 0.1)',
  border: 'solid 1px #ececec',
  textDecoration: 'none',
  marginLeft: 'auto',
  marginRight: 'auto',

  '& .content': {
    padding: '1rem 1rem 1.5rem',
  },

  '& .cover': {
    position: 'relative',
    height: '6.25rem',
    minWidth: '13.75rem',
    borderRadius: 'var(--radii-default)',
    overflow: 'hidden',
    boxSizing: 'unset',
  },
})

const Blog = ({ midia: medusaMidiaProps, title, description, link: href }: BlogProps) => {
  const hasLinksInsideDescription = !!description.match(/<a[^>]*>/)?.length
  const shouldBeALink = href && !hasLinksInsideDescription
  return (
    <BlogStyles {...(shouldBeALink && { as: 'a', href })}>
      <div className="cover">
        <Media layout="responsive" {...medusaMidiaProps} />
      </div>
      <div className="content">
        <BodyM tag={title.tag || 'p'} emphasys className="eu-sm-1">
          {title.text}
        </BodyM>

        <BodyM tag="div" dark="medium" html={description} />
      </div>
    </BlogStyles>
  )
}

export default Blog
